/**
 * Created by win10 on 2017/9/20.
 */
const lang = navigator.language || navigator.userLanguage;
const isEn = lang == "en" || lang == "en-us" || lang == "en-US";
console.log("lang", lang, "isEn", isEn);
const state = {
  include: [], //缓存路由name
  axiosPing: [], //接口防止重复请求
  loading: false, //全局loading
  backFlag: false, //路由返回
  language: localStorage.getItem("language")
    ? localStorage.getItem("language")
    : isEn
    ? "en"
    : "zh", // 多语言
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "", // 登录状态
  userInfo: {}, //用户信息
  platformInfo: {}, //平台信息
  shopCartData: [], //购物车数据
  againOrder: [], //再来一单数据
  location: localStorage.getItem("location")
    ? JSON.parse(localStorage.getItem("location"))
    : {} // 位置信息
};

export default state;
